// Please insert new features in alphabetical order, to preserve readability and reduce chance of merge conflicts
const features = {
    'addin-autoRunAddins': {},
    'addin-complianceVerification': {},
    'addin-delegateAccess': {},
    'addin-getAccessTokenAsync-api': {},
    'addin-inClientStoreEnabled': {},
    'addin-itemSendEvent': {},
    'addin-launchDatapoint': {},
    'addin-officejs-v2': {},
    'addin-oteljs': {},
    'addin-persistentTaskPane': {},
    'an-client-error': {},
    'an-client-network-request': {},
    'an-client-verbose-wl': {},
    'an-full-logging': {},
    'an-no-sample-ppe': {},
    'an-sampled-client-event': {},
    'an-log-assets': {},
    'an-log-usermetrics': {},
    'auth-PremiumDashboard': {},
    'auth-PremiumDashboardApril': {},
    'auth-PremiumSupportControl': {},
    'auth-PremiumSupportTreatment': {},
    'auth-ServiceWorkerEdge': {},
    'auth-ServiceWorkerSafari': {},
    'auth-activityFeed': {
        description: 'Enables the activity feed panel',
    },
    'auth-activityFeedOption': {
        description:
            'Enables the notification Sources option to control the different sources of notification',
    },
    'auth-activityFeedAtMentionsProcessor': {
        description: 'Enables the activity feed mention processor',
    },
    'auth-activityFeedTxpProcessor': {
        description: 'Enables the activity feed TXP processor',
    },
    'auth-activityFeedRenderUserAtMentioned': {
        description: 'Enables the WXP mention rendering.',
    },
    'auth-activityFeedRenderTxpFlight': {
        description: 'Enables the txp flight card in activity feed',
    },
    'auth-authzHeaderNoCookies': {
        description: 'Drop cookies for the requests with authorization header',
    },
    'auth-cloudCache': {},
    'auth-connectedAccounts': {},
    'auth-domainConnect': {},
    'auth-domainConnect-popout': {},
    'auth-domainConnectDemandGen': {},
    'auth-forwardingNotice': {
        description: 'Shows the forwarding notice toast notification at app startup',
    },
    'auth-getAccessTokenQueueEnabled': {
        description: 'Enables Queuing mechanism for GetAccessTokenForResource service call',
    },
    'auth-leftNavInAppUpsell': {},
    'auth-leftNavPremiumUpsell': {},
    'auth-leftNavPremiumUpsellNoCCTreatment': {},
    'auth-LeftNavUpsellFreeServicesTreatment': {},
    'auth-LeftNavUpsellFreeServicesControl': {},
    'auth-LeftNavUpsellAdvancedSecurity': {
        description:
            'Enables an upsell message regarding mailbox security with Office 365 in leftnav',
    },
    'auth-LeftNavUpsellGetMobile': {
        description: 'Enables the upsell message to Get the mobile app in left Nav',
    },
    'auth-linkedInOption': {},
    'auth-mobileDevice': {},
    'auth-PremiumTravelActivateRamp': {},
    'auth-PremiumTravelExpcf': {},
    'auth-PremiumTravelExp': {},
    'auth-PremiumTravelUpsellRamp': {},
    'auth-PremiumTransferDomainTab': {},
    'auth-sharedActivityBasedTimeout': {
        description: 'Enables shared activity based timeout for OWA',
    },
    'auth-TravelDashboardEnabled': {
        description: 'Enables the travel Savings dashboard for premium users',
    },
    'auth-openAnotherMailbox': {
        description: 'Enables the "Open another mailbox" dialog menu item for explicit login',
    },
    'auth-realtimeEmail': {
        description: 'Enables the iris call to send marketing emails for better visibility',
    },
    'auth-safelinksOptionControl': {},
    'cal-cacheDiagnostics': {
        description:
            'Flight to rollout logging of calendar cache diagnostics.  This flight should always be in SDF only, Otherwise we will log this unnecessarily for customers',
    },
    'auth-calendar-serviceworker-cache': {
        description: 'Enables the service worker cache for the calendar app.',
    },
    'cal-CalendarDayListComponent': {},
    'cal-addCalendarFromDirectory': {},
    'cal-addCalendar-teamSnap': {
        description: 'Enables the ability to add TeamSnap account',
    },
    'cal-addCalendar-google': {
        description: 'Feature to expose google in multi accounts for owa calendar',
    },
    'cal-addins': {},
    'cal-advancedRoomBooking': { description: 'cal-mf' },
    'cal-agendaMail-feedback': {},
    'cal-birthday-settings': {},
    'cal-css-variables': {},
    'cal-dimPastEvents': {},
    'cal-dnd-icsfile': {
        description:
            'Flight to enable drag and drop of ics file on calendar to lauch Discover Calendar with Import from File panel',
    },
    'cal-event-duration-setting': {},
    'cal-event-invitation-setting': {},
    'cal-groupCalendarSetColor': {},
    'cal-groupsCalendar': {},
    'cal-groupNotifications': {
        description:
            'Subscribe to calendar item notifications on group calendars. Requires 15.20.2115.000 to be saturated.',
    },
    'cal-ignoreSkipSendingMeetingInviteToGroup': {},
    'cal-ics-preview': {},
    'cal-assumeTzOffsetFromCalendarItem': {
        description:
            "Assumes the time zone offset in a calendar item is correct for the user's time zone.",
    },
    'cal-intelligenceOption': {
        description: 'Whether to show intelligence features in Options',
    },
    'cal-interestingCalendar': {},
    'cal-meetingInsights': {},
    'cal-mf-enableDefaultOnlineMeetingSetting': {
        description: 'Flight to enable option to add Online meeting to all events',
    },
    'cal-mf-agendaMailOption': {
        description: 'Flight to enable agenda mail option',
    },
    'cal-mf-calendarChannelPicker': {
        description: 'Flight to enable the calendar channel picker',
    },
    'cal-mf-insightsInUpNext': {
        description: 'Flights to enable the insights in Up Next',
    },
    'cal-mf-insightsV2': {
        description:
            'Flight to expose meeting insights in notification, calendar peek and event details',
    },
    'cal-mf-insightsEuro': {
        description: 'Flight that enable meeting insights in euro region, i.e. non-English market',
    },
    'cal-mf-hideAttendeeList': {
        description: 'Flight to enable showing the hide attendee list option in calendar compose',
    },
    'cal-mf-enableHideAttendeeListOnSharedCalendar': {
        description:
            'Flight to enable showing the hide attendee list option in calendar compose for shared calendars',
    },
    'cal-mf-joinButton': {
        description: 'Flight to enable showing the new join button for online meetings',
    },
    'cal-mf-locationBusyConfirmation': {
        description:
            'Flight to pop-up a confirm dialog, on meeting updates, when the location is busy in the new time slot.',
    },
    'cal-mf-locationWellShowFreeBusy': {
        description:
            'Flight to enable displaying LocationWell pills with a lower right icon showing FB status',
    },
    'cal-mf-locationwellSearchByCity': {
        description: 'Flight to show room suggestions based on city search.',
    },
    'cal-mf-locationwellAdvancedRoomProperties': {
        description: 'Flight to show Advance Room Properties in location well such as capacity.',
    },
    'cal-mf-quickComposeMergedEvent': {
        description: 'Merge appointment and meeting controls into one UI',
    },
    'cal-mf-quickComposeMergedEventAndOOF': {
        description: 'Flight to show both merge event UI and OOF for SDF and MSIT dogfooders',
    },
    'cal-mf-resourceSchedulingSetting': {
        description: 'Flight to enable resource scheduling setting',
    },
    'cal-mf-superTabbedReadForm': {
        description: 'Show a new tabbed full read form',
    },
    'cal-mf-sendrewardsfortimesuggestions': {
        description:
            'Flight to enable sending rewards to the reinforcement learning endpoint for time suggestions',
    },
    'cal-mf-superMeetingNotes': {
        description:
            'Enable meeting notes viewing and creation, requires cal-mf-superTabbedReadForm to be on',
    },
    'cal-mf-inlineComposeInTimePanel': {
        description: 'show the compose form inline in timepanel instead of pop out',
    },
    'cal-mf-newTimeZonePicker': {
        description: 'Replaces the plain time zone picker with a search-by-city smart field',
    },
    'cal-mf-timezoneinsights': {},
    'cal-mf-availabilityForRecurrence': {
        description: 'Flight to request free busy for recurring meetings in Location Well',
    },
    'cal-mf-defaultRoomsFromLasInRoomPanel': {
        description:
            'Flight to use LAS as the default room provider in the room panel when no filters are selected',
    },
    'cal-mf-diagnostics': {
        description:
            'Flight to rollout logging of calendar forms diagnostics.  This flight should always be in SDF only, Otherwise we will log this unnecessarily for customers',
    },
    'cal-mf-rsvpModel': {
        description: 'Flight to show the new RSVP model (Yes/No/Maybe) underneath notes editor',
    },
    'cal-mf-rsvpModelExp': {
        description:
            'Flight to run RSVP experiment for cal-mf-rsvpModel. Functionality behavior should be the same as cal-mf-rsvpModel',
    },
    'cal-mf-mailCalendarCard': {
        description: 'Flight to enable the calendar card in mail reading pane',
    },
    'cal-mf-mailCalendarCard-recurring': {
        description: 'Flight to enable the calendar card for recurring meetings',
    },
    'cal-mf-quickComposeOOF': {
        description: 'Flight to enable OOF tab in quick compose',
    },
    'cal-mf-sharingOOFWithOthers': {
        description:
            'Flight to enable adding a Recipient Field to the OOF AutomaticReply Options page',
    },
    'cal-mf-readingPaneShyHeader': {
        description: 'Flight to enable the shy header in reading pane',
    },
    'cal-mf-roomBookingAssistant': {
        description: 'Flight to enable book rooom automatically',
    },
    'cal-mf-timeProposalUI': {
        description: 'Flight to enable new organizer review time proposal UI',
    },
    'cal-notificationDiagnostics': {
        description:
            'Flight to rollout logging of calendar notifications diagnostics.  This flight should always be in SDF only, Otherwise we will log this unnecessarily for customers',
    },
    'cal-notifications-expandCalendarEvent': {},
    'cal-pbp-addpsplinktosignature': {
        description:
            'Flight to show a checkbox in signature settings to add the PBP link and a button in PBP settings',
    },
    'cal-personalbookingpage': {
        description: 'Flight to enable Personal booking node in Settings',
    },
    'cal-ppf-celebration': {},
    'cal-print': {},
    'cal-react': {},
    'cal-mf-recurringBookingOutOfPolicyInfoBar': {
        description:
            'Flight to show InfoBar texts to users to indicate room booking will be declines because of Out Of Window policy.',
    },
    'cal-recurrenceThisDateForward': { description: 'cal-mf' },
    'cal-mf-enableFTDFOnSharedCalendar': {
        description:
            'this disables sharedcalendar check so we will be able to edit from this date forward on shared calendars',
    },
    'cal-relatedContent-filesAndEmailsUX': {
        description:
            'Flight to issue 3S recommendation call to fetch files and emails suggestions and show the UX cal-mf',
    },
    'cal-schedulingAssistantAttendeeColors': {},
    'cal-schedulingAssistantGradientColors': {},
    'cal-schedulingAssistantSpacedLegend': {},
    'cal-schoolCalendars': {},
    'cal-sea-addCalendarQuickAction': {},
    'cal-sea-clientSide': {},
    'cal-sea-contextFeedback': {},
    'cal-sea-qf-history': {
        description: 'When enabled, calendar search QF will include history suggestions.',
    },
    'cal-sea-qf-people': {
        description: 'When enabled, calendar search QF will include people suggestions.',
    },
    'cal-sea-query': {},
    'cal-mf-showRoomBookingCapabilities': { description: 'Room panel capability filters.' },
    'cal-stickyNotesFolder': {},
    'cal-surface-boldColorTheme': {},
    'cal-surface-declinedMeetings': {},
    'cal-surface-discover-calendars-experiment': {},
    'cal-surface-expandAllDayWell': {},
    'cal-surface-itemExpand': {},
    'cal-surface-refresh-addCalendar': {},
    'cal-surveyCancelMeetBucket': {
        description: 'Calendar survey bucket triggered by canceling 1 meeting',
    },
    'cal-surveyCreateApptBucket': {
        description: 'Calendar survey bucket triggered by creating 2 appointments',
    },
    'cal-surveyCreateMeetBucket': {
        description: 'Calendar survey bucket triggered by creating 2 meetings',
    },
    'cal-surveyUpdateApptBucket': {
        description: 'Calendar survey bucket triggered by updating 1 appointment',
    },
    'cal-surveyUpdateMeetBucket': {
        description: 'Calendar survey bucket triggered by updating 2 meetings',
    },
    'cal-surveyViewEventBucket': {
        description:
            'Calendar survey bucket triggered by viewing 2 events via details, peek, or meeting card',
    },
    'cal-truTime': {
        description: 'Feature to expose TruTime settings under Availability option for calendar',
    },
    'cal-multiAccounts': {
        description: 'Feature to expose multi accounts capability for owa calendar',
    },
    'cal-mf-room-preferences': { description: 'Feature to enable room preference settings' },
    'cal-txp-editableCard': {},
    'cal-txp-emailDonation': {},
    'cal-txp-inferencesDSAT': {},
    'cal-txp-invoice': {},
    'cal-txp-optionsV2': {},
    'cal-txp-serviceReservation': {},
    'cal-txp-serviceReservationAdaptive': {
        description: 'Feature to enable adaptive service reservation cards in TXP',
    },
    'cal-txp-unblock': {
        description: 'Feature to enable user to unblock themselves in order to use TXP again',
    },
    'cal-showTeamsOrSkypeCharmWhenOnlineMeeting': {
        description:
            'Use Teams or Skype Charm when the user sets an online meeting in Full Compose.',
    },
    'cal-showSingleDayViewWithMultiDaysSubMenu': {
        description:
            'Enable SingleDay view with multiple day submenu options feature in Calendar Surface.',
    },
    'cmp-asyncRecipientWell': {
        description: 'Enables async loading of the recipient well in compose',
    },
    'cmp-galRecipientWellModal': {
        description:
            'Enables a directory (Global Address List) in the compose recipient well labels',
    },
    'cmp-darkMode': {
        description: 'Enables the dark compose experience.',
    },
    'cmp-darkModeSimpleRecolor': {
        description:
            'Controls if we skip the "comparison" step to try to color correct our flipped dark mode for better contrast',
    },
    'cmp-darkModeToggle': {
        description:
            'Exposes a dark mode toggle to switch the editor between dark mode and light mode.',
    },
    'cmp-dictation': {
        description: 'Flag to turn on dictation in compose',
    },
    'cmp-downgradeRawCED': {
        description: 'Downgrade editor to raw CED for debugging',
    },
    'cmp-editorPerfMeasure': {
        description: 'Measure the perf of editor in compose',
    },
    'cmp-dlp-check-irmdata': {
        description:
            'When the flight is not enabled, DLP call is triggered with out checking irmdata. When this is enabled, the following check should happen: If irmdata exists, DLP api call is triggered. If irmdata is not present, DLP api is not triggered. ',
    },
    'cmp-encryption': {},
    'cmp-message-classification': {
        description:
            'Enabled changing message classification in compose and send message with message classification on the out going message.',
    },
    'cmp-clp': {
        description:
            'Whether the clp is enable by tenant. When flag is enabled, each email will be given a sensitivity level and the encryption is applied through labeling instead of the RMS Templates',
    },
    'cmp-hipCheckModal': {
        description:
            'Whether or not to use a modal for the hip check instead of a tab (spam suspicion / account verification)',
    },
    'cmp-hipCheckVendorModal': {
        description: 'Whether the cmp-hipCheckModal should be provided by a vendor',
    },
    'cmp-hipCheckChallengeOnSendFail': {
        description:
            'Whether the cmp-hipCheckModal should be presented immediately on wascl send failure',
    },
    'cmp-implicitgroups': {
        description: 'Implicit group suggestion in mail compose find control',
    },
    'cmp-logOnFrameDropWhileTyping': {
        description: 'Log a datapoint on when a frame is dropped while typing',
    },
    'cmp-prague': {
        description:
            'Enables the prague plugin, a plugin that detects prague links and embeds them into the compose surface.',
    },
    'cmp-pragueAnyLink': {
        description:
            'Disables the checking system for potential prague links, treating every link as a potential prague link.',
    },
    'cmp-quickSwitcher': {
        description: 'Toolbar for moving quickly between areas of the app and running commands',
    },
    'cmp-ribbonBIUS': {
        description: 'Places strikethrough with Bold, Italic, and Underline',
    },
    'cmp-ribbonRemoveFormatAtFront': {
        description: 'Places Remove Format at the front of the ribbon with Format Painter',
    },
    'cmp-ribbonStickyUndo': {
        description:
            'Always display undo as the last non-overflow item on the compose editor ribbon',
    },
    'cmp-smime': { description: 'Toggles whether S/MIME feature is enabled in compose form' },
    'cmp-smimeAdminSettings': {
        description: 'Toggles whether S/MIME admin/user settings is respected in compose form',
    },
    'doc-attachment-contextualSharingTips': {
        description:
            'The flight that covers all beautiful link v2 features such as sharing dialog contextual tips and attach as a copy',
    },
    'doc-attachment-usePrimarySmtpAddressForMailboxId': {},
    'doc-attachment-convoWellDragDrop': {},
    'doc-attachment-documentThumbnail': {},
    'doc-attachment-listViewDragDrop': {},
    'doc-attachment-editingVisualFeature': {},
    'doc-attachment-forgottenAttachmentsDisabled': {
        description:
            'Control tower is down so we are renaming to disable the flight while fixing bugs',
    },
    'doc-attachment-referenceAttachmentExpiration': {},
    'doc-attachment-routingKeyAadSmtp': {},
    'doc-attachment-routingKeyMsa': {},
    'doc-attachment-routingKeyPuid': {},
    'doc-attachment-sharingInfoFailureTip': {},
    'doc-attachment-sharingLinkInfoOWSPrimeService': {},
    'doc-attachment-upsellEntryPoint': {},
    'doc-attachment-urlEncodeRoutingKey': {},
    'doc-link-calendar': {},
    'doc-link-shareCompose': {},
    'doc-filePicker-mailMessageAttachment': {},
    'doc-filePicker-mailMessageSearch': {},
    'doc-filePicker-oneDriveConsumerForO365': {},
    'doc-filePicker-oneDriveProRecentFiles': {},
    'doc-filepicker-preload': {},
    'doc-filePicker-storageAccountView': {},
    'doc-filePicker-thirdPartyProviderClientCalls': {},
    'doc-fileProvider-facebook': {},
    'doc-fileProvider-gdrive': {},
    'doc-fileProvider-box': {},
    'doc-fileProvider-dropbox': {},
    'doc-fileProvider-wopiClient': {},
    'doc-fileshub': {},
    'doc-fileshub-combineFilesandImages': {
        description:
            'if enabled files and images are shown together in fileshub instead of being shown in separate tabs',
    },
    'doc-fileshub-linksInBody': {},
    'doc-fileshub-recommendedAttachments': {},
    'doc-fileshub-sortMenu': {},
    'doc-fileshub-additionalActions': {},
    'doc-SharePoint-dogfoodUser': {},
    'doc-sharepoint-serviceGeneratedLinkTelemetry': {},
    'doc-SxS-jsApi-ODB-Core': {},
    'doc-SxS-jsApi-ODB-Core_Control': {
        description: 'The control flight for doc-SxS-jsApi-ODB-Core',
    },
    'doc-SxS-jsApi-ODB-Word': {},
    'doc-SxS-jsApi-ODB-Excel': {},
    'doc-SxS-jsApi-ODB-PowerPoint': {},
    'doc-SxS-jsApi-ODB-Links': {},
    'doc-SxS-printPdf': {},
    'doc-SxS-saveToCloud': {},
    'doc-SxS-textPreviewEncodingOptions': {},
    'doc-SxS-Wac-Survey': {},
    'doc-SxS-Wac-prefetchStaticResources': {
        description:
            'If enabled it will prefetch WAC static resources (js, css etc.) so that the first load of WAC is more quicker',
    },
    'ext-timeExpressionHighlight': {},
    'feedback-ideas-pane': {},
    'feedback-new-consumer-recruitment': {},
    'fms-dialog': {},
    'fms-dialog-action': {},
    'fwk-ads': {},
    'fwk-ads-callBingTopt': {},
    'fwk-ads-disableDefaultPG': {},
    'fwk-ads-disableFallback': {},
    'fwk-ads-exp2-RuntimeBypass': {},
    'fwk-ads-exp2-StopStampUserOption': {},
    'fwk-ads-exp2-DisplayOffNativeOff': {},
    'fwk-ads-exp2-DisplayOffNativeOther': {},
    'fwk-ads-exp2-DisplayOffNativeInbox': {},
    'fwk-ads-exp2-DisplayOnNativeOff': {},
    'fwk-ads-exp2-DisplayOnNativeOther': {},
    'fwk-ads-exp2-DisplayOnNativeInbox': {},
    'fwk-ads-exp2-ByPassNewUserCheck': {},
    'fwk-ads-kill-GdprPrebid': {
        description: 'Kill switch to stop sending the gdpr information to the prebid process',
    },
    'fwk-ads-noAol-all': {},
    'fwk-ads-noAol-eight-exceptBr': {},
    'fwk-ads-forceMimicAdBlocker': {
        description:
            'Use this flight to test the ad blocker behavior. This flight will never be actually rolled out to the real users',
    },
    'fwk-ads-useWhiteListPg': {
        description: 'Use the white list PG when the effective ad blocker is detected',
    },
    'fwk-batchSubscriptions': {},
    'fwk-bookingsModule': {},
    'fwk-cobranding': {},
    'fwk-consumerWaffle': {},
    'fwk-darkThemeExtended': {},
    'fwk-betterDiagnostics-panel': {
        description: 'Replaces the old diagnostics panel with the upgraded diagnostics panel',
    },
    'fwk-betterDiagnostics-satchel': {
        description:
            'Enables satchel diagnostics middleware to show satchel action details in the diagnostics panel',
    },
    'fwk-betterDiagnostics-service': {
        description:
            'Enables owa-service diagnostics middelware to show service call details in the diagnostics panel',
    },
    'fwk-devTools': {},
    'fwk-emptyPost': {},
    'fwk-errorpopup': {},
    'fwk-feedbackCharm': {},
    'fwk-fluentCommandBar': {},
    'fwk-fluentCommandBar-dropdowns': {},
    'fwk-gdprAdsPrefs': {},
    'fwk-hipExceptionRedirect': {},
    'fwk-improvedExceptionHandler': {},
    'fwk-localeHotReload': {},
    'fwk-moduleSwitcherReuseTab-all': {},
    'fwk-moduleSwitcherReuseTabs': {},
    'fwk-nativeAds-appNexusOneClick': {},
    'fwk-nativeAds-appNexusOneClickOtherInboxOnly': {},
    'fwk-nativeAds-appNexusTwoClick': {},
    'fwk-nativeAds-bingOneClick': {},
    'fwk-nativeAds-bingPrebid': {},
    'fwk-nativeAds-bingOneClickOtherInboxOnly': {},
    'fwk-nativeAds-bingTwoClick': {},
    'fwk-nativeAds-bingTwoClickOtherInboxOnly': {},
    'fwk-nativeAds-honorEasyOtherOffKillSwitch': {},
    'fwk-nativeAds-prebidOneClickAllInbox': {},
    'fwk-nativeAds-prebidOneClickOtherInboxOnly': {},
    'fwk-nativeads-disableIcons': {},
    'fwk-nativeads-fanFillNobid': {},
    'fwk-o365shellheader': {},
    'fwk-o365shellheader-responsive': {},
    'fwk-option-popImap': {},
    'fwk-option-useRestCore': {},
    'fwk-partner-code-off': {},
    'fwk-patchSignalRGetUrl': {},
    'fwk-peopleReact': {},
    'fwk-perf-fps': {},
    'fwk-performanceCharm': {},
    'fwk-prefetch-code-off': {},
    'fwk-prefetch-code-off-chromium': {},
    'fwk-prefetch-data-off': {},
    'fwk-proxyOwsPrime': {},
    'fwk-puidBasedRouting': {
        description:
            'uses PUID:<puid>@tenant as routing hint instead of reading from cookie. This applies to requests made through makeServiceRequest typically used to hit Model B services',
    },
    'fwk-sigs': {},
    'fwk-skypeBusinessV2': {
        description: 'Support UCMA/UCWA/Teams client for business user',
    },
    'fwk-skypeBusinessV2CheckWithFallback': {
        description: 'Use fallback method to check if Teams is enabled',
    },
    'fwk-skypeBusiness-ucmadebug': {
        description:
            'Force using UCMA even user is set to use UCWA/Teams, this is for debugging only',
    },
    'fwk-skypeConsumer': {},
    'fwk-skypeSuite': {
        description:
            'Flight to control whether the O365 Suite Header takes control of initializing Skype',
    },
    'fwk-skypeBusinessCalling': {},
    'fwk-sw-proxyFetchAlways': {},
    'fwk-turnOffCustomData': {},
    'fwk-useJsonNetSerializer': {},
    'fwk-webNotification': {},
    'fwk-webPushNotification': {},
    'fwk-webPushNotificationSignout': {
        description: 'Unsubscribe web push notification on explicit signout',
    },
    'fwk-webPushNotificationV2': {},
    'getStarted-MessageList': {},
    'getStarted-OfficeCard': {},
    'getStarted-PersonalizationCard': {},
    'getStarted-PhoneCard': {},
    'grp-NativeConnectorsPortalEnabled': {
        description: 'If enabled, Connectors portal will be opened in a modal',
    },
    'grp-consumerGroupFilesInGroupHub': {},
    'grp-junkemailitems': {
        description:
            'Display items from Junk Email folder instead of Inbox on group view. Used for debugging purposes only. Only works for item view.',
    },
    'grp-discovery-leftnav': {
        description: 'Enables the Groups Discover workflow',
    },
    'grp-echoSuppressionOption': {},
    'grp-manage-leftnav': {
        description: 'Enables the Groups Hub entry',
    },
    'grp-groupFileshubFRE': {
        description: 'If enabled, shows FRE callouts in Group files hub',
    },
    'grp-groupHeaderV2': {},
    'grp-prefetchSPTokenFromConversations': {
        description: 'If enabled, prefetches token in conversation space',
    },
    'grp-screenshotAutomationTest': {},
    'grp-unreadCountTop5AndFavorites': {},
    'grp-shareable-crud': {},
    'grp-shareable-crud-miplabels': {},
    'grp-suggestUnifiedGroupMembers': {
        description: 'suggestUnifiedGroupMembers API for consumer groups',
    },
    'gsx-translator-translateMessage': {},
    'help-disableTicketFlow': {},
    'help-miniMavenWidget': {},
    'help-o365ShellHeader-MaxPane': {},
    'help-proactiveMessaging': {},

    'inline-feature-feedback': {},

    'lpc-isInBlackforest': {
        description: 'Indicates that the user is in a blackforest tenant',
    },
    'lpc-isInGccModerate': {
        description: 'Indicates that the user is in a GCC-moderate tenant',
    },
    'lpc-isPersonaInsightRingEnabled': {
        description: 'Show rings around persona coins for certain insights in LPC',
    },
    'mailto-group-forms': {
        description: 'Launch group forms via mailto link',
    },
    'mc-augmentationLoop': {
        description: 'Sending events to the augmentation loop in compose for real time annotations',
    },
    'mc-botConversation': {},
    'mc-confetti': {},
    'mc-cortanaCompose': {},
    'mc-contextualSuggestionsCompose': {
        description: 'Enables making a service call for contextual suggestions in compose',
    },
    'mc-contextualSuggestionsComposeExp': {
        description:
            'Enables making a service call for contextual suggestions in compose using experimental model',
    },
    'mc-imageDiagnostics': {},
    'mc-replyWithMRUClassic': {
        description: 'If enabled, we retrieve MRU classic attachments',
    },
    'mc-replyWithMRUCloudyLimited': {
        description:
            'If enabled, we ensure that the MRU service returns at most one cloudy attachment, the rest being classic. For testing purposes only.',
    },
    'mc-replyWithContextualMRU': {
        description:
            'If enabled, we retrieve contexutal attachment suggestions (ordered by last access date)',
    },
    'mc-smartCompose': {},
    'mc-smartComposeExp': {
        description: 'Use experimental model for Smart Compose suggestions',
    },
    'mc-smartComposeFeedback': {
        description: 'Whether or not to show the Smart Compose feedback ribbon',
    },
    'mc-smartReplyWithDoc': {},
    'mc-smartPillsCompose': {
        description: 'Controls showing smart pills in compose',
    },
    'mc-smartPillsFeedbackForm': {
        description: 'New feedback UX for smart pills (yes/no only)',
    },
    'mc-smartPillsFeedbackFormV2': {
        description: 'New feedback UX for smart pills (yes/no and modal)',
    },
    'mc-smartPillsMessageView': {},
    'mc-smartReply': {},
    'mc-smartReplySpanishMexico': {
        description: 'Enables smart reply (text only) in messages that are in Mexican Spanish',
    },
    'mc-smartReplyWithCustomMeeting': {},
    'mc-smartReplyWithMeeting-SuggestedTimeToCAS': {
        description: 'Enable sending specific time suggestion to CAS for smart reply with meeting',
    },
    'mc-smartReplyWithMeeting-Cortana': {
        description:
            'Enable calendar.help (Cortana) to schedule meeting as one of the suggested reply options',
    },
    'mc-smartPillConfidenceLevel_MID': {
        description: 'Enable smart-* pill when confidence score is at the mid level (ex: 80%)',
    },
    'mc-smartPillConfidenceLevel_LOW': {
        description: 'Enable smart-* pill when confidence score is low (ex: 70% or below)',
    },
    'mc-smartPillsRenderingStrategiesV2': {
        description: 'Controls using smart rendering strategies',
    },
    'mc-smartReplyWithTextPositionThird': {
        description: 'Shows Smart Reply with Text Pills at third position.',
    },
    'mc-smartTask': {
        description: 'Controls showing smart task (ex: todo)',
    },
    'mc-smartTaskWithReminder': {
        description: 'Controls showing smart task with reminder',
    },
    'mc-smartSuggestions': {},
    'mc-userHighlighting': {},
    'mc-voting': {
        description: 'Enables the owa mail voting feature',
    },
    'notes-folder-view': {
        description: 'Enables Sticky Notes UX on the Notes folder',
    },
    'nps-fms': {},
    'office-suite-nps': {},
    'peo-ev-header': {},
    'peo-favoritePdls': {
        description: 'Enables Private Distribution Lists favorites',
    },
    'peo-lokiDogfood': {},
    'peo-subjectPicker': {
        description:
            'Enables the default subject picker which comes up on focus into compose subject',
    },
    'peo-subjectPickerButton': {
        description: 'Enables the button for subject picker in compose subject',
    },
    'peo-subjectPickerControl': {
        description: 'Control flight for the subject picker experiment',
    },
    'peo-unauthenticatedSender': {},
    'people-contactCleanupEnterprise': {},
    'people-favoritePicker': {
        description: 'Enables picker in Favorites list in PeopleHub',
    },
    'people-favoritePickerIncludeGroups': {
        description:
            'Groups will be included in picker in Favorites list in PeopleHub. Works if people-favoritePicker flight is enabled',
    },
    'people-emptyFolder-bulk': {
        description: 'Enables loader in any HubList to display a progress of EmptyFolder operation',
    },
    'people-initialGroupsPrefetch': {},
    'people-restoreDeletedItemsFolders': {
        description: 'Adds an option to restore whole folder from leftNav in PeopleHub',
    },
    'people-groupsPrefetch': {},
    'people-searchTypeLabels': {
        description:
            'Enables labels with contact source information in Search Results in PeopleHub',
    },
    'people-groupsMailboxExport': {
        description: 'Enables consumer groups mailbox export in PeopleHub',
    },
    'people-suggestionFolder': {},
    'people-publicFolders': {
        description: 'Enables Public Folders support for PeopleHub, only available in Enterprise',
    },
    'people-option-displayby': {
        description: 'Control "Display by" from Settings page',
    },
    'people-pdlsInCommandBar': {
        description:
            'Enables Dropdown in CommandBar in PeopleHub to add/remove Contacts to ContactLists',
    },
    'people-groupRestoreOnGroupMailbox': {
        description: 'Add the headers in Restore group ows call to land on group mailbox',
    },
    'ring-dogfood': {},
    'ring-microsoft': {},
    'ring-firstrelease': {},
    'ring-ww': {},
    'rp-3SMasking': {},
    'rp-3SPeopleSuggestions': {},
    'rp-acDisableTransactionCard': {
        description: 'Disables the transaction card',
    },
    'rp-actionableMessages': {},
    'rp-actionableMessagesV2': {},
    'rp-actionableMessages-aad-token': {},
    'rp-actionableMessages-contextual': {},
    'rp-actionableMessages-lpc': {},
    'rp-actionableMessages-myanalytics': {},
    'rp-actionableMessages-msa-token': {},
    'rp-addins': {},
    'rp-amp': {},
    'rp-ampDefault': {},
    'rp-appendOnSend': {},
    'rp-brandCards': {},
    'rp-brandCardsUnsubscribe': {},
    'rp-brandDecorations': {},
    'rp-brandListBingManaged': {
        description: 'Adds bing-pages managed brands to the brand list. Requires page refresh',
    },
    'rp-calendarRollup': {},
    'rp-calendarRollupDetailCard': {},
    'rp-csaPinnedLikes': {
        description: 'Pins the like CSA if there are likes on a message',
    },
    'rp-findPeopleSuggestionFeedback': {},
    'rp-floatingActionBar': {},
    'rp-immersiveReader': {},
    'rp-immersiveReaderDogfood': {},
    'rp-inlineTranslation': {
        description: 'Enables inline translation of messages in reading pane',
    },
    'rp-inlineTranslationForwardContent': {
        description: 'Enables inline translation of forward content messages in reading pane',
    },
    'rp-inlineTranslationAutomatic': {
        description: 'Enables automatic inline translation of messages in the reading pane',
    },
    'rp-inlineTranslationManual': {
        description: 'Enables manual entry point for inline translation',
    },
    'rp-inlineTranslation-floodgateSurvey': {
        description: 'Enable floodgate survery for inline translation',
    },
    'rp-inlineTranslation-feedbackRibbon': {
        description: 'Enable feedback ribbon for inline translation',
    },
    'rp-inlineTranslation-conversationViewOff': {
        descriptions:
            'Enabled inline translation of messages in reading pane when conversation view is off',
    },
    'rp-inlineTranslation-targetLanguage': {
        description: 'Enable target language selection for inline translation',
    },
    'rp-inlineTranslationReportWrongLanguageDebug': {
        description: 'Enable link to report incorrect language detection. Internal Only.',
    },
    'rp-imageApiConsumer': {},
    'rp-imageProxyOnModelD': {
        description: 'Enable Image Proxy based on Model-D',
    },
    'rp-inlineTranslation-UseOWS': {
        description:
            'Enables using OWS endpoint for inline translation, otherwise direct call to OGMA',
    },
    'rp-inlineTranslation-DonateContent': {
        description:
            'Enables donation option in feedback ribbon. Applied to consumer accounts only',
    },
    'rp-linkedInPeopleSuggestions': {},
    'rp-opay-modelb-endpoint': {},
    'rp-optimizeAutoSearchDirectory': {},
    'rp-peopleSuggestionsCacheFirst': {},
    'rp-popoutsDebug': {
        description: 'When this feature is on, popout data from local storage will not be cleared',
    },
    'rp-prague': {
        description:
            'Enables the prague content handler, a plugin that detects prague links and embeds them into the reading pane surface.',
    },
    'rp-replyImageProxy': {},
    'rp-selectionUI': {},
    'rp-skypeInTabs': {
        description: 'Feature flag that controls if skype should be put into tabs managed by OWA.',
    },
    'rp-smime': {},
    'rp-userMarkup': {
        description:
            'Shows markup popup with highlighting, note-taking, and quoting options after selecting a portion of the text.',
    },
    'rp-yammer': { description: 'Shows rich Yammer content for select Yammer messages' },
    'sea-advanced-search': {
        description:
            'If on, the revamped advanced search UI will be used to control search refiners.',
    },
    'sea-answers-calendar': {
        description: 'Enables the calendar answer from 3S in search',
    },
    'sea-archive-mailbox-3S': {
        description: 'Search archive mailbox using 3S',
    },
    'sea-calendarSuggestions': {
        description: 'Calendar Entity Suggestions in QF',
    },
    'sea-contextFeedback': {},
    'sea-debugHook': {},
    'sea-emailSuggestions': {
        description: 'Shows email message suggestions on search typedown',
    },
    'sea-extensionQueryAlteration': {
        description: 'This flight enables the Extension QueryAlterationType UX.',
    },
    'sea-fetchMax': {
        description: 'Fetch the max number of results',
    },
    'sea-fileSuggestionAugmentation': {
        description: 'Show quick action buttons on file suggestions from search',
    },
    'sea-filesSuggestions': {
        description: 'Shows files suggestions on search typedown',
    },
    'sea-filterLabel1': {
        description: 'Always show the scope in the filter label',
    },
    'sea-filterLabel2': {
        description: 'Always show the scope in the filter label and show a chevron icon',
    },
    'sea-filterLabel3': {
        description: 'Hide filter label',
    },
    'sea-filterLabel4': {
        description: 'Hide filter label and show a chevron icon',
    },
    'sea-filterLabel5': {
        description: 'Change the filter icon to a chevron icon',
    },
    'sea-findFromSender': {
        description: 'Enables the "Find email from sender" context menu action',
    },
    'sea-floodgateSurveySDFSampling': {
        description: 'Floodgate survey flag to indicate SDF different sampling',
    },
    'sea-folderTagAll': {
        description: 'Show the folder tag in all search scopes',
    },
    'sea-gf': {
        description: 'Enables GF (advanced suggestions) in the search box',
    },
    'sea-gf1': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gf2': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gf3': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gf4': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gf5': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gf6': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gfct1': {
        description:
            'Control flight for GF (advanced suggestions) experiment. See WI 40315 for more information about flight configuration.',
    },
    'sea-hybridSearchSupported': {
        description:
            'This flight is enabled for environments where hybrid search (for ExecuteSearch) is supported.',
    },
    'sea-lazy2': {
        description:
            'Uses refactored (lazy) search packages and 3S-powered ZINQ suggestions when enabled.',
    },
    'sea-lazyccf2': {
        description:
            'Custom control flight for sea-lazy2 where the new packages will not be used, but users will have 3S-powered ZINQ suggestions.',
    },
    'sea-modificationQueryAlteration': {
        description: 'This flight enables the Modification QueryAlterationType UX.',
    },
    'sea-naturalLanguage': {
        description:
            'When enabled, we request that the service optimizes search queries that are natural language.',
    },
    'sea-folderScope': {
        description: 'Enables searching by folder scope',
    },
    'sea-personaCardInSuggestions': {
        description: 'Shows persona card in the suggestions on hover of which we shall open LPC',
    },
    'sea-prefixHH': {
        description: 'Hit highlight based off prefix instead of substring',
    },
    'sea-qf': {},
    'sea-qf-headers': {
        description: 'Adds headers in suggestions callout',
    },
    'sea-nextSearchBoxInteractions': {
        description: 'Enables next search box interactions',
    },
    'sea-searchBoxInteractionsClear': {
        description: 'Gates the clear search box button visiblity',
    },
    'sea-searchHistoryApi': {
        description:
            "If enabled, we'll make requests to new SearchHistory API when deleting/exporting search history.",
    },
    'sea-sendPillDisplayText': {
        description:
            'Prepends pills (using their DisplayText) to the query text sent in suggestions calls.',
    },
    'sea-spellingCorrectedSearchNoResults': {
        description: 'If enabled, we show "no results" specific speller UX.',
    },
    'sea-substrateQuery': {},
    'cal-time-panel': {},
    'cal-time-panel-dragEscalateMeeting': {
        description: 'allows for dragging and dropping into the time panel to create a meeting',
    },
    'todo-panel': {},
    'todo-flagged-email-list': {},
    'tra-cacheTranslation': {
        description: 'Allow translation of items to be stored as extended property.',
    },
    'tra-EnableShortMessage': {
        description: 'Allow short messages to be translated.',
    },
    'tri-coupon-peek': {},
    'tri-distributionGroupsOption': {
        description: 'Shows distribution management in the options page',
    },
    'tri-dynamicLayout': {
        description: 'Controls the dynamic layout of the mail module',
    },
    'tri-conversationView-folderTags': {
        description: 'Folder tags in conversation view',
    },
    'tri-hoverIconsUI': {
        description: 'UI update for hover icons',
    },
    'tri-favoriteSearch': {},
    'tri-favorites-roaming': {
        description: 'Enables Roaming favorites served from Prime endpoint.',
    },
    'tri-filterMenuRedesign': {
        description: 'Redesigned filter / sort menu',
    },
    'tri-flag-complete': {
        description: 'Show flag complete menu in list view right click menu',
    },
    'tri-inboxPlusDefaultTabs': {
        description: 'Inbox plus feature with default tab set',
    },
    'tri-inboxPlusDefaultTabsControl': {
        description: 'Inbox plus feature with default tab set (control group)',
    },
    'tri-meetingMessageRSVP': {
        description: 'Allows user to initiate meeting actions from the ListView',
    },
    'tri-meetingMessageRSVPExp': {
        description:
            'Flight to run experiment for tri-meetingMessageRSVP. Functionality behavior should be the same as tri-meetingMessageRSVP.',
    },
    'tri-moduleSwitcherBehavior': {
        description: 'Open workload in same tab instead of new tab',
    },
    'tri-nudge': {
        description:
            'bring email that users may have missed to read or forgotten to follow up to the top of list view',
    },
    'tri-nudgeFeedback': {
        description: 'feedback dialog for nudge in reading pane info bar',
    },
    'tri-pauseInbox': {
        description: 'Stop incoming mail from coming into inbox',
    },
    'tri-reportAbuse': {
        description: 'Adds report abuse action to ListView and ReadingPane drop down',
    },
    'tri-reportAbuseArisEndpoint': {
        description: 'Adds report abuse action to ListView and ReadingPane drop down',
    },
    'tri-scrollMoreDataPoint': {
        description: 'Logging to determine how far users scroll down list view',
    },
    'tri-smartMergeFindResponse': {
        description:
            'Merges the FindConv/FindItem with the cached response data only if the lastModifiedTime changed',
    },
    'tri-snooze': {
        description: 'Adds snooze feature to delay message delivery.',
    },
    'tri-suppressMarkReadBehaviorOnRF': {
        description: 'When enabled we shall suppress the mark read server behavior upon r/R/F',
    },
    'tri-sweepBulkAction': {
        description:
            'Controls whether bulk actions payloads will be sent from the server for sweep',
    },
    'tri-triageFolderScope': {
        description:
            'When enabled triage actions are performed at folder scope context (and at search folder scope when disabled)',
    },
    'tri-triagePattern': {
        description: 'Learn user triage pattern and suggest appropriate actions',
    },
    'tri-turnOffFocusedOther': {
        description: 'Adds a dialog in the mail list header to prompt user to turn off FO',
    },
    'tri-autoMarkReadInUnreadSetting': {
        description: 'Adds setting to support auto mark as read in the unread filter',
    },
    'tri-upNextV2': {
        description: 'Display the upcoming event in the commanding bar',
    },
    'tri-fasterInboxRulesLoader': {
        description: 'Use faster server-side inbox rules loader',
    },
    'tri-runInboxRulesNow': {
        description: 'Allow all inbox rules to be run now',
    },
    'usv-forum': {},
    'usv-nps': {},
    'usv-nps-5-rating-scale': {},
    'whatsNew-Pane': {},
};

export default features;
export type FeatureName = Extract<keyof typeof features, string>;
